import styled from 'styled-components';

export const PaginationWrapper = styled.ul`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-direction: row;
  margin-top: 3rem;
`;
